import { render, staticRenderFns } from "./TheFooter.vue?vue&type=template&id=4d55de36&scoped=true&"
import script from "./TheFooter.js?vue&type=script&lang=js&"
export * from "./TheFooter.js?vue&type=script&lang=js&"
import style0 from "./TheFooter.scss?vue&type=style&index=0&id=4d55de36&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d55de36",
  null
  
)

export default component.exports